<p-dialog header="Asignar Dispositivos" [(visible)]="visible" [modal]="true" [style]="{width: '700px', maxHeight: '85vh'}" (onHide)="close()" [dismissableMask]="true">

  <!-- Summary + actions -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
    <div class="flex items-center gap-3">
      <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" placeholder="Buscar dispositivo..." (keyup)="searchByText($event)" class="w-60" />
      </p-iconfield>
      <span class="text-xs text-vivid-royal-400">{{ assignedCount }}/{{ totalCount }} asignados</span>
    </div>
    <button pButton [label]="assignedCount === totalCount ? 'Deseleccionar todos' : 'Seleccionar todos'" class="p-button-text p-button-sm" (click)="selectAll()"></button>
  </div>

  <!-- Table -->
  <p-table [value]="deviceData" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template #header>
      <tr>
        <th class="w-[50px]"></th>
        <th>Dispositivo</th>
        <th>Usuario</th>
        <th>Placas</th>
      </tr>
    </ng-template>
    <ng-template #body let-item>
      <tr class="cursor-pointer" (click)="select(item)"
        [ngClass]="{'bg-vivid-royal-50 dark:bg-vivid-royal-900': item.deviceType === '1' || item.deviceType === '2'}">
        <td class="text-center">
          @switch(item.deviceType) {
            @case('0') { <i class="pi pi-circle text-gray-300 text-lg"></i> }
            @case('1') { <i class="pi pi-check-circle text-green-500 text-lg"></i> }
            @case('2') { <i class="pi pi-check-circle text-mustard-700 dark:text-mustard-400 text-lg"></i> }
            @case('4') { <i class="pi pi-times-circle text-red-400 text-lg"></i> }
          }
        </td>
        <td class="font-mono font-semibold">{{ item.vehicle }}</td>
        <td>{{ item.nameUser }}</td>
        <td>{{ item.plates }}</td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr><td colspan="4" class="text-center py-6 text-vivid-royal-400">No existen dispositivos</td></tr>
    </ng-template>
  </p-table>

  <!-- Legend -->
  <div class="flex flex-wrap gap-4 text-xs text-vivid-royal-400 pt-3">
    <span><i class="pi pi-check-circle text-green-500 mr-1 align-middle"></i> Asignado</span>
    <span><i class="pi pi-check-circle text-mustard-700 dark:text-mustard-400 mr-1 align-middle"></i> Por asignar</span>
    <span><i class="pi pi-times-circle text-red-400 mr-1 align-middle"></i> Por desasignar</span>
    <span><i class="pi pi-circle text-gray-300 mr-1 align-middle"></i> Disponible</span>
  </div>

  <ng-template #footer>
    @if(dataResult.length > 0) {
      <button pButton label="Cancelar" class="p-button-text" (click)="cancel()"></button>
      <button pButton label="Guardar cambios" icon="pi pi-check" (click)="save()"></button>
    }
  </ng-template>
</p-dialog>
